export default {
  notificationDetails: 'Notifications Details',
  'notificationDetails.reference': 'Reference: ',
  'notificationDetails.referenceId': '{{reference}}',
  'notificationDetails.category': 'Category: ',
  'notificationDetails.categoryText': '{{category}}',
  'notificationDetails.greeting': 'Dear {{customerName}},',
  'notificationDetails.subject': '{{subject}}',
  'notificationDetails.message': '{{message}}',
};
